import { notifications } from "@mantine/notifications"
import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import { AxiosError } from "axios"
import { useTranslation } from "react-i18next"

import {
  ContactRequests,
  ContactResponses,
} from "@tfg/types/endpoints/contacts"

import { httpClient } from "~/backend/axios.ts"
import { queryClient } from "~/backend/queryClient.ts"

export const useEditContactMutation = (
  contactId: number,
  options?: UseMutationOptions<
    ContactResponses.Contact,
    AxiosError,
    ContactRequests.CreateContact
  >
) => {
  const { t } = useTranslation("traceability")
  return useMutation({
    ...options,
    mutationFn: async (variables) => {
      return (
        await httpClient.put<ContactResponses.Contact>(
          `/contacts/${contactId}`,
          variables
        )
      ).data
    },
    onSuccess: async (data, variables, context) => {
      options?.onSuccess?.(data, variables, context)

      notifications.show({
        message: t("contactModal.messages.success", { email: variables.email }),
        color: "teal",
      })
      await queryClient.invalidateQueries(["listContacts"])
    },
    onError: (error, variables, context) => {
      notifications.show({
        message: t("contactModal.messages.error", {
          error: error.response?.data ?? error.message,
        }),
        color: "red",
      })
      options?.onError?.(error, variables, context)
    },
  })
}
